import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { LAYOUT_CARD_PROFILE, LAYOUT_CARD_MEDIUM, SECTION_CATEGORY } from '@wix/communities-blog-client-common';
import CommentListItem from '../../../app/components/comment-search-list-item';
import PostListItem from '../../../app/components/post-list-item';
import { getLayoutConfig } from '../../../app/services/layout-config';
import styles from './like-list.scss';
import { getConfig } from '../../../app/services/config';

const renderComment = (
  { like, onCommentLikeClick, onPostLikeClick }, // eslint-disable-line react/prop-types
) => (
  <CommentListItem
    section={SECTION_CATEGORY}
    layoutType={LAYOUT_CARD_PROFILE}
    type="profile"
    comment={like}
    onPostLikeClick={onPostLikeClick}
    onLikeClick={onCommentLikeClick}
    showLikeButton={true}
  />
);

const renderPost = (
  { like, onPostLikeClick }, // eslint-disable-line react/prop-types
) => {
  const { postPageSectionUrl } = getConfig();

  return (
    <PostListItem
      section={SECTION_CATEGORY}
      layoutType={LAYOUT_CARD_PROFILE}
      type="medium"
      post={like}
      onLikeClick={onPostLikeClick}
      itemConfig={get(getLayoutConfig(LAYOUT_CARD_MEDIUM), 'itemConfig')}
      showProfileImage={like?.showProfileImage}
      onLinkClick={() => (window.top.location.href = `${postPageSectionUrl}/${like.slug}`)}
    />
  );
};

const RENDER_MAP = {
  comment: renderComment,
  post: renderPost,
};

const LikeList = ({ likes, ...props }) => (
  <div>
    {likes.map((like) => (
      <div key={`${like.type}-${like._id}`} className={styles.item}>
        {RENDER_MAP[like.type]({ like, ...props })}
      </div>
    ))}
  </div>
);

LikeList.propTypes = {
  likes: PropTypes.arrayOf(PropTypes.object),
  onCommentLikeClick: PropTypes.func.isRequired,
  onPostLikeClick: PropTypes.func.isRequired,
};

export default LikeList;
